import { Environments } from 'src/types/Environments';
import { Marketplace, Marketplaces } from 'src/types/Marketplaces';

// marketplace ids - https://tiny.amazon.com/4r4ib5ow/monsmonsamazdevsitesell
// This object controls which marketplaces are shown in the switcher
export const MARKETPLACES_NA: Marketplaces[] = [
  Marketplaces.brazil,
  Marketplaces.canada,
  Marketplaces.mexico,
  Marketplaces.usa,

];

export const MARKETPLACES_EU: Marketplaces[] = [
  Marketplaces.uk,
  Marketplaces.france,
  Marketplaces.italy,
  Marketplaces.germany,
  Marketplaces.spain,
  Marketplaces.india,
  Marketplaces.uae,
  Marketplaces.turkey,
  Marketplaces.netherlands,
  Marketplaces.poland,
  Marketplaces.sweden,
  Marketplaces.saudi_arabia,
  Marketplaces.egypt,
  Marketplaces.belgium,
];

export const MARKETPLACES_FE: Marketplaces[] = [
  Marketplaces.japan,
  Marketplaces.australia,
  Marketplaces.singapore,
];

export enum MarketplaceRegions {
  NA = 'NA',
  EU = 'EU',
  FE = 'FE',
}

export const MARKETPLACES: Record<Marketplaces, Marketplace> = {
  [Marketplaces.australia]: {
    [Environments.prod]: 'A39IBJ37TRP1C6',
    [Environments.gamma]: 'A39IBJ37TRP1C6',
    [Environments.beta]: 'A1RNPCQ4K8U27I',
    flag: 'flag-au',
  },
  [Marketplaces.belgium]: {
    [Environments.prod]: 'AMEN7PMS3EDWL',
    [Environments.gamma]: 'AMEN7PMS3EDWL',
    [Environments.beta]: 'A1YFOMBPFBRY22',
    flag: 'flag-be',
  },
  [Marketplaces.brazil]: {
    [Environments.prod]: 'A2Q3Y263D00KWC',
    [Environments.gamma]: 'A2Q3Y263D00KWC',
    [Environments.beta]: 'AZXD3QD5B39HD',
    flag: 'flag-br',
  },
  [Marketplaces.canada]: {
    [Environments.prod]: 'A2EUQ1WTGCTBG2',
    [Environments.gamma]: 'A2EUQ1WTGCTBG2',
    [Environments.beta]: 'A2EUQ1WTGCTBG2',
    flag: 'flag-ca',
  },
  [Marketplaces.egypt]: {
    [Environments.prod]: 'ARBP9OOSHTCHU',
    [Environments.gamma]: 'ARBP9OOSHTCHU',
    [Environments.beta]: 'AUJPM9XGFJRC7',
    flag: 'flag-eg',
  },
  [Marketplaces.france]: {
    [Environments.prod]: 'A13V1IB3VIYZZH',
    [Environments.gamma]: 'A13V1IB3VIYZZH',
    [Environments.beta]: 'A13V1IB3VIYZZH',
    flag: 'flag-fr',
  },
  [Marketplaces.germany]: {
    [Environments.prod]: 'A1PA6795UKMFR9',
    [Environments.gamma]: 'A1PA6795UKMFR9',
    [Environments.beta]: 'A1PA6795UKMFR9',
    flag: 'flag-de',
  },
  [Marketplaces.india]: {
    [Environments.prod]: 'A21TJRUUN4KGV',
    [Environments.gamma]: 'A21TJRUUN4KGV',
    [Environments.beta]: 'A2XZLSVIQ0F4JT',
    flag: 'flag-in',
  },
  [Marketplaces.italy]: {
    [Environments.prod]: 'APJ6JRA9NG5V4',
    [Environments.gamma]: 'APJ6JRA9NG5V4',
    [Environments.beta]: 'A3HOBANJMCMD83',
    flag: 'flag-it',
  },
  [Marketplaces.japan]: {
    [Environments.prod]: 'A1VC38T7YXB528',
    [Environments.gamma]: 'A1VC38T7YXB528',
    [Environments.beta]: 'A1VC38T7YXB528',
    flag: 'flag-jp',
  },
  [Marketplaces.mexico]: {
    [Environments.prod]: 'A1AM78C64UM0Y8',
    [Environments.gamma]: 'A1AM78C64UM0Y8',
    [Environments.beta]: 'A3P3J5A7D2ZVXI',
    flag: 'flag-mx',
  },
  [Marketplaces.netherlands]: {
    [Environments.prod]: 'A1805IZSGTT6HS',
    [Environments.gamma]: 'A1805IZSGTT6HS',
    [Environments.beta]: 'A1M3WC0SJ3A38T',
    flag: 'flag-nl',
  },
  [Marketplaces.poland]: {
    [Environments.prod]: 'A1C3SOZRARQ6R3',
    [Environments.gamma]: 'A1C3SOZRARQ6R3',
    [Environments.beta]: 'AKY4K4WKH21YQ',
    flag: 'flag-pl',
  },
  [Marketplaces.saudi_arabia]: {
    [Environments.prod]: 'A17E79C6D8DWNP',
    [Environments.gamma]: 'A17E79C6D8DWNP',
    [Environments.beta]: 'A1MQPSGJ6U9Q54',
    flag: 'flag-sa',
  },
  [Marketplaces.singapore]: {
    [Environments.prod]: 'A19VAU5U5O7RUS',
    [Environments.gamma]: 'A19VAU5U5O7RUS',
    [Environments.beta]: 'A1DQ6JV7I20JSG',
    flag: 'flag-sg',
  },
  [Marketplaces.spain]: {
    [Environments.prod]: 'A1RKKUPIHCS9HS',
    [Environments.gamma]: 'A1RKKUPIHCS9HS',
    [Environments.beta]: 'AJZF8LZ1EJVJN',
    flag: 'flag-es',
  },
  [Marketplaces.sweden]: {
    [Environments.prod]: 'A2NODRKZP88ZB9',
    [Environments.gamma]: 'A2NODRKZP88ZB9',
    [Environments.beta]: 'AT614YYYNOC1S',
    flag: 'flag-se',
  },
  [Marketplaces.turkey]: {
    [Environments.prod]: 'A33AVAJ2PDY3EV',
    [Environments.gamma]: 'A33AVAJ2PDY3EV',
    [Environments.beta]: 'A3CQBQD3RGPJR8',
    flag: 'flag-tr',
  },

  [Marketplaces.uae]: {
    [Environments.prod]: 'A2VIGQ35RCS4UG',
    [Environments.gamma]: 'A2VIGQ35RCS4UG',
    [Environments.beta]: 'A34GYYCZVDBSIK',
    flag: 'flag-ae',
  },
  [Marketplaces.uk]: {
    [Environments.prod]: 'A1F83G8C2ARO7P',
    [Environments.gamma]: 'A1F83G8C2ARO7P',
    [Environments.beta]: 'A1F83G8C2ARO7P',
    flag: 'flag-uk',
  },
  [Marketplaces.usa]: {
    [Environments.prod]: 'ATVPDKIKX0DER',
    [Environments.gamma]: 'ATVPDKIKX0DER',
    [Environments.beta]: 'ATVPDKIKX0DER',
    flag: 'flag-us',
  },
};

export const DEFAULT_MAKETPLACE_URL_HOST = 'localhost:3000';

export const MARKETPLACE_URL_TO_ID_MAP: { [url: string]: string } = {
  [DEFAULT_MAKETPLACE_URL_HOST]: 'ATVPDKIKX0DER',
  'rainier-m1k.integ.amazon.com': 'ATVPDKIKX0DER',
  'rainier-ca.integ.amazon.com': 'A2EUQ1WTGCTBG2',
  'rainier-mx.integ.amazon.com': 'A3P3J5A7D2ZVXI',
  'rainier-br.integ.amazon.com': 'AZXD3QD5B39HD',
  'rainier-eu.integ.amazon.com': 'A1F83G8C2ARO7P',
  'rainier-in.integ.amazon.com': 'A2XZLSVIQ0F4JT',
  'rainier-jp.integ.amazon.com': 'A1VC38T7YXB528',
  'sellercentral-au-beta.integ.amazon.com': 'AZXD3QD5B39HD',
  'sellercentral-nl-beta.integ.amazon.com': 'A1M3WC0SJ3A38T',
  'sellercentral-tr-beta.integ.amazon.com': 'A3CQBQD3RGPJR8',
  'rainier-cn.integ.amazon.com': 'AAHKV2X7AFYLW',

  // GAMMA
  'gamma.sellercentral.amazon.dev': 'ATVPDKIKX0DER',
  'seller-central-cn-onebox.amazon.com': 'AAHKV2X7AFYLW',
  'seller-central-eu-onebox.amazon.com': 'A1F83G8C2ARO7P',
  'seller-central-jp-onebox.amazon.com': 'A1VC38T7YXB528',
  'seller-central-master.amazon.com': 'ATVPDKIKX0DER',
  'sellercentral-ae-gamma.aka.amazon.com': 'A2VIGQ35RCS4UG',
  'sellercentral-au-gamma.aka.amazon.com': 'A39IBJ37TRP1C6',
  'sellercentral-be-gamma.aka.amazon.com': 'AMEN7PMS3EDWL',
  'sellercentral-cl-gamma.aka.amazon.com': 'A2WDZJZ5TCRMLH',
  'sellercentral-co-gamma.aka.amazon.com': 'A1ZXRLSQW2V54D',
  'sellercentral-eg-gamma.aka.amazon.com': 'ARBP9OOSHTCHU',
  'sellercentral-mena-gamma.aka.amazon.com': 'A2VIGQ35RCS4UG',
  'sellercentral-ng-gamma.aka.amazon.com': 'A3OCL2LJ6GDH9T',
  'sellercentral-nl-gamma.aka.amazon.com': 'A1805IZSGTT6HS',
  'sellercentral-pl-gamma.aka.amazon.com': 'A1C3SOZRARQ6R3',
  'sellercentral-sa-gamma.aka.amazon.com': 'A17E79C6D8DWNP',
  'sellercentral-sg-gamma.aka.amazon.com': 'A19VAU5U5O7RUS',
  'sellercentral-se-gamma.aka.amazon.com': 'A2NODRKZP88ZB9',
  'sellercentral-tr-gamma.aka.amazon.com': 'A33AVAJ2PDY3EV',
  'sellercentral-za-gamma.aka.amazon.com': 'AE08WJ6YKNBMC',
  'rainier-mx-preprod.amazon.com': 'A1AM78C64UM0Y8',
  'rainier-br-preprod.amazon.com': 'A2Q3Y263D00KWC',

  // PROD
  'sellercentral-europe.amazon.com': 'A1F83G8C2ARO7P',
  'sellercentral-japan.amazon.com': 'A1VC38T7YXB528',
  'sellercentral-mena.amazon.com': 'A2VIGQ35RCS4UG',
  'sellercentral.amazon.ae': 'A2VIGQ35RCS4UG',
  'sellercentral.amazon.ca': 'A2EUQ1WTGCTBG2',
  'sellercentral.amazon.cl': 'A2WDZJZ5TCRMLH',
  'sellercentral.amazon.co.jp': 'A1VC38T7YXB528',
  'sellercentral.amazon.co.uk': 'A1F83G8C2ARO7P',
  'sellercentral.amazon.co.za': 'AE08WJ6YKNBMC',
  'sellercentral.amazon.com': 'ATVPDKIKX0DER',
  'sellercentral.amazon.com.au': 'A39IBJ37TRP1C6',
  'sellercentral.amazon.com.be': 'AMEN7PMS3EDWL',
  'sellercentral.amazon.com.br': 'A2Q3Y263D00KWC',
  'sellercentral.amazon.com.co': 'A1ZXRLSQW2V54D',
  'sellercentral.amazon.com.mx': 'A1AM78C64UM0Y8',
  'sellercentral.amazon.com.ng': 'A3OCL2LJ6GDH9T',
  'sellercentral.amazon.com.tr': 'A33AVAJ2PDY3EV',
  'sellercentral.amazon.de': 'A1PA6795UKMFR9',
  'sellercentral.amazon.dev': 'ATVPDKIKX0DER',
  'sellercentral.amazon.eg': 'ARBP9OOSHTCHU',
  'sellercentral.amazon.es': 'A1RKKUPIHCS9HS',
  'sellercentral.amazon.fr': 'A13V1IB3VIYZZH',
  'sellercentral.amazon.it': 'APJ6JRA9NG5V4',
  'sellercentral.amazon.in': 'A21TJRUUN4KGV',
  'sellercentral.amazon.nl': 'A1805IZSGTT6HS',
  'sellercentral.amazon.pl': 'A1C3SOZRARQ6R3',
  'sellercentral.amazon.sa': 'A17E79C6D8DWNP',
  'sellercentral.amazon.se': 'A2NODRKZP88ZB9',
  'sellercentral.amazon.sg': 'A19VAU5U5O7RUS',

  'wl.amazon.cn': 'AAHKV2X7AFYLW',
  'mai.amazon.cn': 'AAHKV2X7AFYLW',
};
